/**
 * Parses the NFT metadata and options to create an NFT object.
 * @param base - The base NFT metadata.
 * @param options - The options for parsing the NFT.
 * @returns The parsed NFT object.
 * @internal
 */
export function parseNFT(base, options) {
    switch (options.type) {
        case "ERC721":
            return {
                metadata: base,
                owner: options?.owner ?? null,
                id: options.tokenId,
                tokenURI: options.tokenUri,
                type: options.type,
            };
        case "ERC1155":
            return {
                metadata: base,
                owner: options?.owner ?? null,
                id: options.tokenId,
                tokenURI: options.tokenUri,
                type: options.type,
                supply: options.supply,
            };
        default:
            throw new Error("Invalid NFT type");
    }
}
//# sourceMappingURL=parseNft.js.map